export default "__VITE_ASSET__8rx1uMNl__"